<template>
  <Form :submit-function="createSiteInfo" :editable=false />
</template>

<script>
import Form from './Form';

export default {
  name: "Create",
  components: {Form},
  methods: {
    createSiteInfo(form) {
      this.$store.dispatch('SiteInfo/createSiteInfo', form);
    }
  }
}
</script>

<style scoped>

</style>